import React from 'react';
import { CardTypes, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import ProblemsContent from 'shared-assets/facesheet-ui/components/Facesheet/Problems/ProblemsContent';
import HistoryContent from 'shared-assets/facesheet-ui/components/Facesheet/History/HistoryContent';
import LabsContent from 'shared-assets/facesheet-ui/components/Facesheet/Labs/LabsContent';
import MedicationsContent from 'shared-assets/facesheet-ui/components/Facesheet/Medications/MedicationsContent';
import VitalsContent from 'shared-assets/facesheet-ui/components/Facesheet/Vitals/VitalsContent';
import RecommendationsContent from 'shared-assets/facesheet-ui/components/Facesheet/ClinicalRecommendations/RecommendationsContent';
var CardContentContainer = function (_a) {
    var type = _a.type, data = _a.data, patientId = _a.patientId, patientStatus = _a.patientStatus;
    var getCardContent = function (type) {
        switch (type) {
            case CardTypes.Problems:
                return (React.createElement(ProblemsContent, { problemsData: data, hasNoKnownProblems: patientStatus === null || patientStatus === void 0 ? void 0 : patientStatus.noKnownProblems }));
            case CardTypes.History:
                return React.createElement(HistoryContent, { historyData: data, patientId: patientId });
            case CardTypes.Labs:
                return React.createElement(LabsContent, { labsData: data });
            case CardTypes.Medications:
                return (React.createElement(MedicationsContent, { medicationsData: data, hasNoKnownMedications: patientStatus === null || patientStatus === void 0 ? void 0 : patientStatus.noKnownMedications }));
            case CardTypes.Vitals:
                return React.createElement(VitalsContent, { vitalsData: data });
            case CardTypes.Recommendations:
                return (React.createElement(RecommendationsContent, { patientId: patientId, recommendationsData: data }));
        }
    };
    return React.createElement(React.Fragment, null, getCardContent(type));
};
export default CardContentContainer;
